var _rect, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeleteCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 30,
    viewBox: "0 0 42 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.980469,
    width: 40.979,
    height: 30,
    rx: 15,
    fill: "#D01717"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.5921 12.8401C28.5921 20.8591 29.7464 24.4839 21.9825 24.4839C14.2178 24.4839 15.3959 20.8591 15.3959 12.8401",
    fill: "#D01717"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5921 12.8401C28.5921 20.8591 29.7464 24.4839 21.9825 24.4839C14.2178 24.4839 15.3959 20.8591 15.3959 12.8401",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.0684 9.76562H13.918H30.0684Z",
    fill: "#D01717"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0684 9.76562H13.918",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.417 9.76571C25.417 9.76571 25.9455 6 21.9913 6C18.0379 6 18.5665 9.76571 18.5665 9.76571",
    fill: "#D01717"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25.417 9.76571C25.417 9.76571 25.9455 6 21.9913 6C18.0379 6 18.5665 9.76571 18.5665 9.76571",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteCircle);
export default __webpack_public_path__ + "static/media/delete-circle.58fc6fcb203c7cffac7fd5c6962532db.svg";
export { ForwardRef as ReactComponent };